<template>
	<div>
		<div @click="godetail(data)"
			class="item padding-tb-sm padding-lr-sm margin-bottom-sm  flex flex-direction justify-between">
			<p class="text-cut text-left title">{{data.title}}</p>
			<div class="flex justify-between align-start">
				<div class="flex align-center">
					<p class="tip-item text-333 round margin-right-19 text-sm" style="max-width: 260rpx;">{{data.category[0].work_categroy_name}}</p>
					<p class="tip-item text-333 round margin-right-19 text-sm">{{data.settlement}}</p>
					<p class="tip-item text-333 round margin-right-19 text-sm">{{data.experience}}年经验</p>
				</div>
				<div class="flex flex-direction justify-between align-center">
					<p class=" text-prices text-bold title"  :class="data.salary == '面议'?'':'text-price'">{{data.salary}}</p>
					<p class="text-999 text-xs">{{data.salary == '可面议'?'薪资待遇':'月薪待遇'}}</p>
				</div>
			</div>
			<p class="text-left text-sm text-ccc">发布于{{data.create_time}}</p>
			<div class="sticky text-center fu-fs26">已置顶</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Object,
				default: {}
			}
		},
		mounted() {

		},
		methods: {
			godetail(data) {
				this.$emit('godetail',data)
			}
		}
	};
</script>

<style scoped lang="less">
	.item {
		width: 921px;
		height: 168px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		position: relative;

		.title {
			font-size: 24px;
		}

		.block-63 {
			width: 36px;
			height: 36px;
			border-radius: 50%;
		}

		.block-15 {
			width: 15px;
			height: 15px;
		}

		.add {
			width: 16px;
			height: 19px;
		}

		.margin-left-8 {
			margin-left: 8px;
		}

		.sticky {
			position: absolute;
			top: 0;
			right: 0;
			width: 45px;
			height: 24px;
			font-size: 13px;
			line-height: 24px;
			background: rgba(11, 131, 124, 0.1);
			border-radius: 0px 20px 0px 0px;
			color: #0B837C;
		}

		.tip-item {
			font-size: 13px;
			padding: 5px 10px;
			border-radius: 12px;
			background: #F1F1F1;
			margin-right: 9px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/list/recruit-list.vue